export default {
    setWidth(state, string) {

        state.width = string
    },
    setHeight(state, string) {
        state.height = string
    },
    setRatio(state, string) {
        state.ratio = string
    },
    setLock(state, string) {
        state.lock = !state.lock
    },
}